<div class="modal flex-direction-column gap-54 padding-15px">
  <div class="flex-direction-column gap-5">
    <span class="font-14 weight-700">{{ texto }}</span>
    @if (subTexto) {
      <span class="font-14 weight-700">{{ subTexto }}</span>
    }
  </div>

  <div class="flex-direction-column gap-10">
    <app-button-padrao
      label="Sim"
      color="#61B460"
      backgroundColor="white"
      borderColor="#61B460"
      borderStyle="solid"
      borderWidth="2px"
      fontWeight="600"
      width="100%"
      (buttonClick)="fechar()"
    ></app-button-padrao>

    <app-button-padrao
      label="Não"
      color="#BD1D00"
      backgroundColor="white"
      borderColor="#BD1D00"
      borderStyle="solid"
      borderWidth="2px"
      fontWeight="600"
      width="100%"
      (buttonClick)="continuar()"
    ></app-button-padrao>
  </div>
</div>
